import {
	titleContainerSX,
	titleLineSX,
	titleSX,
} from '@/components/blocks/SectionTitle/styles/sectionTitle';
import { Box, Typography } from '@mui/material';

type SectionTitleProps = {
	title: string;
};

export const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => (
	<Box sx={titleContainerSX}>
		<Box sx={titleLineSX} />
		<Typography variant="headingMainTitle" component="h1" sx={titleSX}>
			{title}
		</Typography>
	</Box>
);
